export const departmentContacts = [

  {
    departmentLabel: 'Service Department (Dial 2)',
    email: null,
    phone: '1-800-255-9215',
    categoryId: '8104e9e3-9e51-480c-8d7c-576aa885656a',
  },

  {
    departmentLabel: 'Parts Department (Dial 1)',
    email: null,
    phone: '1-800-255-9215',
    categoryId: 'fe5672f8-a8f9-44f4-a592-9e00cc89d260',
  },

  {
    departmentLabel: 'Wholegoods Department',
    phone: '1-800-255-0132',
    extension: '1987',
    categoryId: '2f79b6d9-69d3-44ab-b659-18d1f3d6e8b6',
  },

  {
    departmentLabel: 'Credit Department',
    email: null,
    phone: '800-472-0166',
    extension: null,
    categoryId: 'e04ae47c-5233-44ab-ab11-4230b3a3373f',
  },

  {
    departmentLabel: 'Sales & Marketing Department',
    phone: '1-800-255-0132',
    email: 'gpsales@greatplainsmfg.com',
    categoryId: 'd080c98b-1742-4067-926b-10194a39e829',
  },

  {
    departmentLabel: 'Warranty Department',
    phone: '1-800-255-0132',
    extension: '1342',
    categoryId: '69fd55a3-17ca-431b-86ce-629d33186509',
  },

]